import { Grid, MenuItem, Paper, TextField, Typography } from '@material-ui/core'
import { CheckIcon, ErrorPaperIcon, QuestionPaperIcon } from 'asterX-UI/Icons'
import { useRopInfoStyles } from './rop-info.styles'
import { ConversationCard } from 'components/ConversationCard/ConversationCard'
import { BASE_COLORS, ERROR_COLORS, SUCCESS_COLORS } from 'asterX-UI'
import { useHomeStoreRop } from 'context/HomeStore/Rop'
import { formatTime } from 'lib/utils'
import RopInfoTable from './RopInfoTable'
import { useAuthStore } from 'context/AuthStore'
import { RopCard } from 'components/Rop/RopCard/RopCard'

export const RopInfo = () => {
  const classes = useRopInfoStyles()
  const {
    authStore: { user }
  } = useAuthStore()
  const {
    homeStore: {
      selectedBranch,
      selectedMng,
      branches,
      subdivisions,
      managers,
      ropStatistics,
      seoList,
      statusesCount,
      selectedSubdivision
    },
    homeStoreFunc: { setSelectedMng, setSelectedBranch, setSelectedSubdivision }
  } = useHomeStoreRop()

  const formatNumber = number =>
    number ? number.toString().substring(0, 4) : 0

  const getCountByCode = code => {
    const status = statusesCount.find(item => item.code === code)
    return status ? status.count : 0
  }

  const count50 = getCountByCode('50') // "Демонстрация"
  const count60 = getCountByCode('60') // "Выбор авто"
  const count65 = getCountByCode('65') // "На оформлении договора"
  const count70 = getCountByCode('70') // "Подбор авто"

  const progressCards = [
    {
      label: 'Талон А,C',
      value: seoList?.talonAC || '0'
    },
    {
      label: 'Талон М',
      value: seoList?.talonM || '0'
    },
    {
      label: 'На подборе авто',
      value: count70 || '0'
    },
    {
      label: 'На демонстрации',
      value: count50 || '0'
    },
    {
      label: 'На выборе авто',
      value: count60 || '0'
    },
    {
      label: 'На оформлении',
      value: count65 || '0'
    },
    {
      label: 'Текущая очередь',
      value: seoList?.countInQueue || '0'
    },
    {
      label: 'Ср. время ожидания',
      value: formatTime(seoList?.avgQueueTime) || '0'
    },
    {
      label: 'Обслуживается',
      value: seoList?.countInService || '0'
    },
    {
      label: 'Ср. время услуг',
      value: formatTime(seoList?.avgServiceTime) || '0'
    },
    {
      label: 'Завершили',
      value: seoList?.countCompleted || '0'
    },
    {
      label: 'Ср вр. работы с кл.',
      value: formatTime(seoList?.avgTotalTime) || '0'
    }
  ]

  return (
    <Grid container spacing={2}>
      <Grid item container xs={12} md={12} spacing={2}>
        <Grid item xs={12} md={3}>
          <TextField
            select
            label={'Филиал'}
            value={selectedBranch || ''}
            onChange={({ target: { value } }) => setSelectedBranch(value)}
            fullWidth
          >
            {branches?.map((b, i) => (
              <MenuItem key={`branch_${i}`} value={b.code}>
                {b?.name}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField
            select
            label={'Звено'}
            value={selectedSubdivision?.id || ''}
            onChange={({ target: { value } }) =>
              setSelectedSubdivision(subdivisions?.find(s => s.id === value))
            }
            fullWidth
          >
            {subdivisions?.map((s, i) => (
              <MenuItem key={`branch_${i}`} value={s.id}>
                {s?.rop}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12} md={3}>
          <TextField
            select
            label={'Менеджер'}
            value={selectedMng}
            onChange={({ target: { value } }) => setSelectedMng(value)}
            fullWidth
          >
            {managers?.map((m, i) => (
              <MenuItem key={`branch_${i}`} value={m.username}>
                {m.fullName + ' @' + m.username}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
        style={{ display: 'flex', alignItems: 'stretch' }}
      >
        <Paper
          className={classes.ropCardsWrapper}
          style={{ padding: '25px 16px' }}
        >
          <Grid container xs={12} md={12} spacing={2} direction={'row'}>
            <Grid item xs={12} md={12}>
              <Typography variant={'h6'}> РОП</Typography>
            </Grid>
            <Grid item xs={12} md={4}>
              <RopCard
                title="На согласовании"
                value={ropStatistics?.onApproval || 0}
                color="orange"
                icon={<QuestionPaperIcon />}
              />
            </Grid>{' '}
            <Grid item xs={12} md={4}>
              <RopCard
                title="Просроченные задачи"
                value={ropStatistics?.overdueTasks || 0}
                color="red"
                icon={<CheckIcon />}
              />
            </Grid>{' '}
            <Grid item xs={12} md={4}>
              <RopCard
                title="Непроверенные РЛ"
                value={ropStatistics?.unverifiedWL || 0}
                color="red"
                icon={<ErrorPaperIcon />}
              />
            </Grid>
          </Grid>
        </Paper>
      </Grid>
      <Grid item container xs={12} md={6} spacing={2} direction={'column'}>
        <Grid item>
          <Paper className={classes.ropCardsWrapper}>
            <Grid container xs={12} md={12} spacing={2} direction={'row'}>
              <Grid item xs={12} md={12}>
                <Typography variant={'h6'}>Операции по РЛ</Typography>
              </Grid>
              <Grid item xs={4} md={4}>
                {' '}
                <ConversationCard
                  label={`${formatNumber(
                    ropStatistics?.conversion?.applications
                  )}`}
                  description="Новый контракт"
                />
              </Grid>{' '}
              <Grid item xs={4} md={4}>
                <ConversationCard
                  label={`${formatNumber(ropStatistics?.conversion?.ticketT)}`}
                  description="Талон Т"
                />
              </Grid>{' '}
              <Grid item xs={4} md={4}>
                <ConversationCard
                  label={`${formatNumber(ropStatistics?.conversion?.carst)}`}
                  description="Подводы"
                />
              </Grid>
            </Grid>
          </Paper>
        </Grid>
        <Grid item>
          <Paper className={classes.ropCardsWrapper}>
            <Grid container xs={12} md={12} spacing={2} direction={'row'}>
              <Grid item xs={12} md={12}>
                <Typography variant={'h6'} display={'inline'}>
                  {' '}
                  Результаты{' '}
                </Typography>
                <Typography variant={'subtitle1'} display={'inline'}>
                  за сегодня
                </Typography>
              </Grid>
              <Grid item xs={6} md={6}>
                <ConversationCard
                  label={ropStatistics?.succeeded || 0}
                  color={SUCCESS_COLORS[700]}
                  description="Проданные"
                />
              </Grid>{' '}
              <Grid item xs={6} md={6}>
                <ConversationCard
                  label={ropStatistics?.missed || 0}
                  color={ERROR_COLORS[700]}
                  description="Упущенные"
                />
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>
      <Grid item xs={12} md={12}>
        <Paper className={classes.ropCardsWrapper}>
          <Grid container xs={12} md={12} spacing={2} direction={'row'}>
            <Grid item xs={12} md={12}>
              <Typography variant={'h6'} display={'inline'}>
                {' '}
                Прогресс по РЛ{' '}
              </Typography>
              <Typography variant={'subtitle1'} display={'inline'}>
                за сегодня
              </Typography>
            </Grid>
            {progressCards.map(v => (
              <Grid item xs={6} md={2}>
                <ConversationCard
                  label={v.value}
                  color={BASE_COLORS.Black}
                  description={v.label}
                />
              </Grid>
            ))}
          </Grid>
        </Paper>
      </Grid>
      <RopInfoTable />
    </Grid>
  )
}
